var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.svgImageContainer,style:({ 'max-width': _vm.width })},[_c(require(("../../../assets" + _vm.src)).default,{tag:"component",class:_vm.$style.svgImageContainer__image})],1)}
var staticRenderFns = []

export { render, staticRenderFns }